import { render, staticRenderFns } from "./RecommendedPosts.vue?vue&type=template&id=52d18482&scoped=true"
import script from "./RecommendedPosts.vue?vue&type=script&lang=js"
export * from "./RecommendedPosts.vue?vue&type=script&lang=js"
import style0 from "./RecommendedPosts.vue?vue&type=style&index=0&id=52d18482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d18482",
  null
  
)

export default component.exports